import React, { useEffect, useState, useRef, useContext } from "react";
import { store } from '../context/store';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { LICENCE_KEY } from "../constants/charts";

am4core.addLicense(LICENCE_KEY);

export default function AmChartDateStackedEmptyTop({ chartId, dateKey, chartData, chartKeys, height, width, onClick }) {
  const chart = useRef(null);
  const globalState = useContext(store);
  
  const sortedData = chartData.sort((a, b) => new Date(a.date) - new Date(b.date));

  useEffect(() => {
    let x = am4core.create(chartId, am4charts.XYChart);

    x.paddingRight = 20;
    x.stroke = "#666";
    x.strokeWeight = 0;
    x.strokeOpacity = 0;
    x.fontSize = 11;
    x.fill = 'black';
    x.strokeAlpha = 0;
    x.cursor = new am4charts.XYCursor();
    x.scrollbarX = new am4core.Scrollbar();

    let dateAxis = x.xAxes.push(new am4charts.DateAxis());

		dateAxis.baseInterval = { timeUnit: "hour", count: 1 };  // base unit
		dateAxis.skipEmptyPeriods = true;                        // don't pad empty gaps
		dateAxis.strictMinMax = true;         

		dateAxis.dateFormats.setKey("hour", "dd MMM HH:mm");
		dateAxis.dateFormats.setKey("day", "dd MMM HH:mm");
		dateAxis.periodChangeDateFormats.setKey("hour", "dd MMM HH:mm");
		dateAxis.periodChangeDateFormats.setKey("day", "dd MMM HH:mm");
		
		
    dateAxis.strokeWidth = 0;
    dateAxis.renderer.labels.template.fill = 'black';
    dateAxis.renderer.minGridDistance = 15;
    dateAxis.renderer.grid.template.strokeDasharray = "1,3";
    dateAxis.renderer.labels.template.rotation = -90;
    dateAxis.renderer.labels.template.horizontalCenter = "right";
    dateAxis.renderer.labels.template.location = 0.3;
    dateAxis.renderer.cellStartLocation = 0.3;
    dateAxis.renderer.cellEndLocation = 0.7;
    dateAxis.renderer.labels.template.disabled = false;
    dateAxis.renderer.labels.template.fontSize=9;

    dateAxis.renderer.axisFills.template.disabled = false;
    dateAxis.renderer.axisFills.template.fillOpacity = 0.1;
    dateAxis.renderer.axisFills.template.fill = 'black';
    dateAxis.renderer.axisFills.template.strokeOpacity = 0;

    let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.labels.template.fill = 'black';
    valueAxis.strokeWidth = 0;
    valueAxis.title.text = "Occupancy/Capacity"; // Add axis title here
    valueAxis.title.fontSize = 14;
    valueAxis.title.fill = "black";

    // Create series for both data elements
    for (let i = 0; i < chartKeys.length; i++) {
      let series = x.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = chartKeys[i].name;
      series.dataFields.dateX = dateKey;
      series.tooltipText = " ({dateX.formatDate('dd MMM HH:mm')}): {valueY}";

      series.columns.template.width = am4core.percent(100);
      series.stacked = true;
      series.columns.template.stroke = "#000";

      // Set fill and stroke for the series
      if(i == 1){
      	series.columns.template.fill = 'white';
      }
      else{
      	series.columns.template.fill = chartKeys[i].color;
      }
      series.columns.template.stroke = chartKeys[i].color;
      series.columns.template.strokeWidth = 1;
      
      // Make both columns solid
      series.columns.template.fillOpacity = 1; // Ensures no transparency

      // Set up event listener
      series.columns.template.events.on("hit", function (event) {
        onClick(event.target.dataItem.properties.category);
      });
    }

    // Setup number formatting
    x.numberFormatter.numberFormat = "#.00a";
    x.numberFormatter.bigNumberPrefixes = [
      { "number": 1e+3, "suffix": "K" },
      { "number": 1e+6, "suffix": "M" },
      { "number": 1e+9, "suffix": "Bn" }
    ];

   

    // Set chart data
    x.data = sortedData;
    chart.current = x;

    // Cleanup function
    return () => {
      x.dispose();
    };
  }, [chartData]);

  return (
    <div id={chartId} style={{ width: '100%', height: height }}></div>
  );
}
